import { useEffect } from 'react';
import { blockPageClose, unblockPageClose } from '../pageCloseBlocking';

const useBlockPageClose = (isBlocked: boolean): void => {
  useEffect(() => {
    if (!isBlocked) {
      return;
    }

    const pageCloseBlockerId = blockPageClose();

    return (): void => {
      unblockPageClose(pageCloseBlockerId);
    };
  }, [isBlocked]);
};

export default useBlockPageClose;
